import PropTypes from 'prop-types';
import { TableCell, TableRow, Typography, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { appStr } from 'src/locales/app_strings';
import LinkTextField from 'src/components/widgets/link-textfield'
import PaginatedTable from 'src/components/ui/table/paginated-table';
import HeaderTableCell from 'src/components/ui/table/header-table-cell';

export const ListTable = (props) => {
  const {
    dataStore,
    onPageChange = () => {},
    onRowsPerPageChange,
    page = 0,
    rowsPerPage = 0,
    selected = [],
    onDetailClicked,
  } = props;

  const { t } = useTranslation();

  return (
    <PaginatedTable
      items={dataStore.items}
      loading={dataStore.loading}
      page={page}
      rowsPerPage={rowsPerPage}
      onPageChange={onPageChange}
      onRowsPerPageChange={onRowsPerPageChange}
      renderItem={(item, rowstyle) => (
        <TableRow hover selected={selected.includes(item.id)} sx={rowstyle}>
          <TableCell>
            <LinkTextField sx={{color: item.hasTicket ? 'error.main' : 'inherit'}}
              value={item.plateNumber} onClick={() => onDetailClicked(item)} />
          </TableCell>
          <TableCell>
            <Box sx={{ display: 'inline-block', textAlign: 'right' }}>
              <Typography variant="body2" color={item.dayColor}>
                {item.checkIn}
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5}}>
                {item.checkOut}
              </Typography>
            </Box>
          </TableCell>
          <TableCell>
            <Box sx={{ display: 'inline-block'}}>
              <Typography variant="body1">
                <Box component="span">
                  {item.checkinBy}
                </Box>
                <Box component="span" sx={{ color: 'text.secondary', m: 1 }}>-</Box>
                <Box component="span">
                  {item.checkoutBy}
                </Box>
              </Typography>
            </Box>
          </TableCell>
          <TableCell>
            <Typography variant="body1">
              {item.distance}
            </Typography>
          </TableCell>
          <TableCell sx={{ textAlign: 'right' }}>{item.contactName}</TableCell>
        </TableRow>
      )}
    >
      <TableRow>
        <HeaderTableCell sx={{ width: '17%' }}>{t(appStr.txt_034)}</HeaderTableCell>
        <HeaderTableCell sx={{ width: '20%' }}>{t(appStr.txt_030)}</HeaderTableCell>
        <HeaderTableCell sx={{ width: '20%' }}>Giờ xe Ra - Về</HeaderTableCell>
        <HeaderTableCell sx={{ width: '13%' }}>Số km</HeaderTableCell>
        <HeaderTableCell sx={{ textAlign: 'right', whiteSpace: 'nowrap' }}>{t(appStr.txt_049)}</HeaderTableCell>
      </TableRow>
    </PaginatedTable>
  );
};

ListTable.propTypes = {
  dataStore: PropTypes.object,
  onDeselectAll: PropTypes.func,
  onDeselectOne: PropTypes.func,
  onPageChange: PropTypes.func,
  onRowsPerPageChange: PropTypes.func,
  onSelectAll: PropTypes.func,
  onSelectOne: PropTypes.func,
  page: PropTypes.number,
  rowsPerPage: PropTypes.number,
  selected: PropTypes.array,
};
